<template>
  <vs-popup class="vs-con-loading__container user-edit-popup"
            id="popup"
            title="CREATE INVOICE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="vx-col w-full">
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(CreateInvoice)" autocomplete="off">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                  <small class="label">Price</small>
                  <vs-input v-model="invoice.price" name="name" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="setup_charge" name="setupCharge" rules="required" v-slot="{ errors }">
                  <small class="label">Setup Charge</small>
                  <vs-input v-model="invoice.setup_charge" name="setupCharge" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3  w-full md:mb-0">
                <ValidationProvider vid="price_discount" name="priceDiscount" rules="required" v-slot="{ errors }">
                  <small class="label">Price Discount</small>
                  <vs-input v-model="invoice.price_discount" name="priceDiscount" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3  w-full md:mb-0">
                <ValidationProvider vid="additional_staffs_block" name="additionalStaffsBlock" rules="required" v-slot="{ errors }">
                  <small class="label">additional Staffs Block</small>
                  <vs-input v-model="invoice.additional_staffs_block" name="additionalStaffsBlock" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3  w-full md:mb-0">
                <ValidationProvider vid="additional_staffs_discount" name="additionalStaffsDiscount" rules="required" v-slot="{ errors }">
                  <small class="label">additional Staffs Discount</small>
                  <vs-input v-model="invoice.additional_staffs_discount" name="additionalStaffsDiscount" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2  w-full md:mb-0">
                <ValidationProvider vid="customer_portal_price" name="customerPortalPrice" rules="required" v-slot="{ errors }">
                  <small class="label">Customer Portal Price</small>
                  <vs-input v-model="invoice.customer_portal_price" name="customerPortalPrice" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2  w-full md:mb-0">
                <ValidationProvider vid="customer_portal_discount" name="customerPortalDiscount" rules="required" v-slot="{ errors }">
                  <small class="label">customer Portal Discount</small>
                  <vs-input v-model="invoice.customer_portal_discount" name="customerPortalDiscount" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2  w-full md:mb-0">
                <ValidationProvider vid="supplier_portal_price" name="supplierPortalPrice" rules="required" v-slot="{ errors }">
                  <small class="label">Supplier Portal Price</small>
                  <vs-input v-model="invoice.supplier_portal_price" name="supplierPortalPrice" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2  w-full md:mb-0">
                <ValidationProvider vid="supplier_portal_discount" name="supplierPortalDiscount" rules="required" v-slot="{ errors }">
                  <small class="label">Supplier Portal Discount</small>
                  <vs-input v-model="invoice.supplier_portal_discount" name="supplierPortalDiscount" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="flex flex-wrap items-center justify-end mt-8">
              <vs-button button="submit" class="ml-auto mt-2">Create</vs-button>
              <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
export default {
  name: "CreateInvoicePopUp",
  data() {
    return {
      open: false,
      invoice: {}
    }
  },
  methods: {
    async openPopUp() {
      this.open = true;
    },
    async CreateInvoice() {
      //
    },
    onClickReset() {
      //
    }
  }
}
</script>

<style scoped>

</style>
